import { ToastifyService } from './ToastifyService';

export default new ToastifyService();
